import { render } from "./Bundle.vue?vue&type=template&id=558780d5&scoped=true"
import script from "./Bundle.vue?vue&type=script&lang=js"
export * from "./Bundle.vue?vue&type=script&lang=js"

import "./Bundle.vue?vue&type=style&index=0&id=558780d5&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-558780d5"

export default script